export interface IPNSPasswordResetVerification {
  username: string;
  token: string;
  resetCode: string;
}
